// components
import {
  SidebarProvider,
  useSidebar,
  Sidebar,
  SidebarButtonHome,
} from "@shared/Sidebar";

export const SidebarSupport = () => {
  const sidebar = useSidebar();

  return (
    <SidebarProvider value={sidebar}>
      <Sidebar>
        <div
          className="d-flex flex-column h-100 "
          data-testid="sidebar-support"
        >
          <div className="d-flex flex-column gap-3 h-100 justify-content-between">
            <div className="d-flex flex-column gap-3">
              <SidebarButtonHome />
            </div>
          </div>
        </div>
      </Sidebar>
    </SidebarProvider>
  );
};
